import React from 'react';
import FsgoItem from './FsgoItem'

class FsgoItems extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const title = this.props.title;
		const state = this.props.state;
		const videos = this.props.items;
		let idx = 1;

		return (
			<li className="tune-in-item">
				<div className="tune-in-item-container">
					<div className="live">
						<div className="title">{title}</div>
						<span className="separator"></span>
						<div className="content">
							<ul className="videos">
								{videos.map((v) => {
									return (
										<FsgoItem item={v} state={state} idx={idx++}/>
									);
								})}
							</ul>
						</div>
					</div>
				</div>
			</li>
		)
	}
}

export default FsgoItems;



// WEBPACK FOOTER //
// ./react-app-src/fsgo/components/FsgoItems.js